export const DND_TYPE = {
    ENTITY: 'ENTITY',
    GROUP: 'GROUP',
}
